





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { VisitorsRecord } from '@/core/data/sets/VisitorsRecord';
import { Common } from '@/core/Common';
import { FView } from '@/core/FView';
import { DataType } from '@/core/data/DataType';
import { WeekRecordGroup } from '@/core/data/sets/computed/WeekRecordGroup';
import moment from 'moment';

@Component ({
  components: {
      
  },
})
export default class extends Vue {
    getDataSet(): WeekRecordGroup[] {
        return WeekRecordGroup.getVisitorsByWeeks();
    }

    getDayNames() {
        return Common.GetWeekDaysShort();
    }

    formatDate(dt: string): string {
      return Common.FormatDate(dt);
    }

    getDayColor(day: number) {
        return Common.IsWeekendDay(day) ? "#C11" : "#111"
    }

    getDayClass(day: number) {
        return Common.IsWeekendDay(day) ? "holiday" : "";
    }
}
